import React from 'react';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { urgency } from '../data/content';
interface CountdownPanelProps {
  showScarcity?: boolean;
}
export function CountdownPanel({
  showScarcity = true
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds,
    remainingRatio
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'ore'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const remainingPercent = Math.max(0, Math.min(100, remainingRatio * 100));
  return <div className="mx-auto w-full max-w-4xl text-center" data-id="element-50" data-mp="c690v9s2ovf5">
      <p className="inline-flex items-center gap-2 text-sm font-extrabold uppercase tracking-widest text-blue-700 md:text-base" data-id="element-51" data-mp="c7tvezee0ed0">
        <ClockIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-52" data-mp="26k9vfiglaw9f" />
        {urgency.title}
      </p>

      <div className="mt-6 flex items-start justify-center gap-4 md:gap-8" role="timer" data-id="element-53" data-mp="2bithdiv6o81s">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-54" data-mp="1lgf4kxvkz26s">
            <span className="text-5xl font-extrabold tabular-nums leading-none tracking-tight text-blue-600 md:text-7xl" data-id="element-55" data-mp="1hfv4blfpnigf">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-widest text-blue-900/60" data-id="element-56" data-mp="1v94ald8d3nuq">
              {unit.label}
            </span>
          </div>)}
      </div>

      {showScarcity && <div className="mt-8" data-id="element-57" data-mp="12kf93d3e9gig">
          <p className="inline-flex items-center gap-2 rounded-xl bg-red-50 px-4 py-2.5 text-sm font-semibold text-red-600 ring-1 ring-red-100 md:text-base" data-id="element-58" data-mp="yh92g4cddnbg">
            <AlertTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-59" data-mp="1cefihr5pl7wz" />
            {urgency.priceNote}
          </p>

          <div className="mt-7" data-id="element-60" data-mp="2nvfa0kk8fipy">
            <p className="text-left text-sm font-semibold text-blue-900/70" data-id="element-61" data-mp="2numd0bb2s7l0">
              {urgency.limitedNote}
            </p>
            <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-blue-100" aria-hidden="true" data-id="element-62" data-mp="2iwch1yhj12yc">
              <div className="h-full rounded-full bg-blue-600" style={{
            width: `${remainingPercent}%`
          }} data-id="element-63" data-mp="2uycbeb8br24r" />
            </div>
          </div>
        </div>}
    </div>;
}